import { render, staticRenderFns } from "./dialog-table-facilitators.vue?vue&type=template&id=66f1c6c2&scoped=true&"
import script from "./dialog-table-facilitators.vue?vue&type=script&lang=js&"
export * from "./dialog-table-facilitators.vue?vue&type=script&lang=js&"
import style0 from "./dialog-table-facilitators.vue?vue&type=style&index=0&id=66f1c6c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f1c6c2",
  null
  
)

export default component.exports